import { useState } from "react";

import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import axios from "axios";
import { Field, Form, Formik } from "formik";
import { TextField } from "formik-mui";
import queryString from "query-string";
import * as Yup from "yup";

import { COLOR_KICK_BLUE } from "~/shared/sharedConstants.js";
import { kickGreen } from "~/shared/styles/baseStyles.js";
import { TextMaskPhone } from "~/visits/components/shared.jsx";

const initialValues = {
  magicLinkToken: "",
  email: "",
  phone: "",
};

export default function PortalSendMagicLink({ sms }) {
  const [magicLinkError, setMagicLinkError] = useState("");
  const [magicLinkMessage, setMagicLinkMessage] = useState(<p></p>);

  const parsedQS = queryString.parse(location.search);

  if (parsedQS.token) {
    initialValues.magicLinkToken = parsedQS.token;
  }

  const validationSchema = sms
    ? Yup.object().shape({
        phone: Yup.string().required("Phone number is required"),
      })
    : Yup.object().shape({
        email: Yup.string().email().required("Email is required"),
      });

  const renderSendMagicLinkForm = () => {
    return (
      <Formik
        validationSchema={validationSchema}
        initialValues={initialValues}
        onSubmit={(values, { setSubmitting }) => {
          axios
            .post("/me/send-magic-link/", {
              email: values.email,
              phone: values.phone.replace(/[^0-9]/g, ""),
            })
            .then(() => {
              setSubmitting(false);

              setMagicLinkMessage(
                <p style={{ color: kickGreen }}>
                  {sms ? (
                    "Text sent"
                  ) : (
                    <>
                      Email sent. Check your inbox for a login email. <br />
                      Make sure to check your spam folder too.
                    </>
                  )}
                </p>,
              );
              setMagicLinkError("");
            })
            .catch((error) => {
              setSubmitting(false);
              console.error("Error sending link:", error.response);
              console.log(error);
              setMagicLinkError(error.response.data.errors?.[0].title);
              setMagicLinkMessage(<p></p>);
            });
        }}
      >
        {(props) => (
          <Form
            style={{
              display: "flex",
              width: "100%",
              maxWidth: "300px",
              flexDirection: "column",
              alignItems: "center",
              margin: "0 auto 30px",
            }}
          >
            <p style={{ textAlign: "center", marginBottom: "20px" }}>
              What {sms ? "phone number" : "email address"} did you sign up
              with?
              <br />
              We'll send you a link to sign into your account
            </p>
            {sms ? (
              <Field
                component={TextField}
                defaultValue=""
                id="phone"
                name="phone"
                label="Phone"
                type="phone"
                variant="outlined"
                fullWidth
                InputProps={{
                  inputComponent: TextMaskPhone,
                }}
              />
            ) : (
              <Field
                component={TextField}
                id="email"
                name="email"
                label="Email"
                type="email"
                variant="outlined"
                fullWidth
              />
            )}

            <div
              style={{
                textAlign: "center",
                marginTop: "10px",
                color: "red",
              }}
            >
              {magicLinkError}
            </div>
            <div
              style={{
                textAlign: "center",
                marginTop: "10px",
              }}
            >
              {magicLinkMessage}
            </div>

            <Button
              disabled={props.isSubmitting}
              type="submit"
              color="primary"
              size="large"
              style={{
                backgroundColor: COLOR_KICK_BLUE,
                color: "white",
                marginTop: "10px",
                width: "80%",
                justifySelf: "center",
                alignSelf: "center",
                display: "flex",
                flex: "1",
              }}
            >
              Send Login Link
            </Button>
          </Form>
        )}
      </Formik>
    );
  };

  return (
    <Grid
      container
      justifyContent="center"
      style={{
        backgroundColor: COLOR_KICK_BLUE,
      }}
    >
      <Grid
        item
        style={{ display: "flex", flexDirection: "column" }}
        md={8}
        xs={10}
      >
        <div
          style={{
            backgroundColor: "white",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            borderRadius: "10px",
            padding: "20px",
            maxWidth: "100%",
            margin: "40px 0",
          }}
        >
          <Typography
            style={{
              fontFamily: "BasisGrotesquePro-Bold",
              fontSize: "24px",
              textAlign: "center",
              margin: "30px 0 20px 0",
            }}
          >
            {sms ? "Text Me" : "Email"} a Login Link
          </Typography>
          {renderSendMagicLinkForm()}
        </div>
      </Grid>
    </Grid>
  );
}
